import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./Navbar.css";
import adflynLogo from "../../assets/logo/adflynLogo.png";

// NavLink component moved outside for better performance
const NavLink = ({ children, onClick }) => (
  <button 
    type="button" 
    className="nav-link" 
    onClick={onClick}
  >
    {children}
  </button>
);

// Scroll to section helper
const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

NavLink.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) setScrolled(isScrolled);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  return (
    <div className="app-container">
        <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
          {/* Logo */}
          <Link to="/" className="logo-section">
            <img src={adflynLogo} alt="Adflyn Logo" className="adflyn-logo" />
          </Link>

          {/* Desktop Nav Links */}
          <div className="nav-links-wrapper">
            <NavLink onClick={() => scrollToSection('primary-feature')}>Features</NavLink>
            <NavLink onClick={() => scrollToSection('testimonials')}>Testimonials</NavLink>
            <NavLink onClick={() => scrollToSection('faq')}>FAQ</NavLink>
          </div>

          {/* Desktop Button */}
          <button className="signup-button desktop-only" onClick={() => window.open('https://app.youform.com/forms/qw5x4urb', '_blank')}>
            Join waitlist
            <svg className="icon-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>

          {/* Mobile Toggle */}
          <button
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? (
              <svg className="icon" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
            ) : (
              <svg className="icon" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg>
            )}
          </button>
        </nav>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-links">
            <NavLink onClick={() => { scrollToSection('primary-feature'); setMobileMenuOpen(false); }}>Features</NavLink>
            <NavLink onClick={() => { scrollToSection('testimonials'); setMobileMenuOpen(false); }}>Testimonials</NavLink>
            <NavLink onClick={() => { scrollToSection('faq'); setMobileMenuOpen(false); }}>FAQ</NavLink>
            <button className="signup-button mobile-only" onClick={() => window.open('https://app.youform.com/forms/qw5x4urb', '_blank')}>
              Join waitlist
              <svg className="icon-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
  );
}

export default Navbar;